import React from "react";
import { BiMaleFemale } from "react-icons/bi";
import { MdOutlineLocalLaundryService } from "react-icons/md";
import { GiLovers } from "react-icons/gi";
import {
  FaWheelchair,
  FaSmoking,
  FaSmokingBan,
  FaMale,
  FaFemale,
  FaCat,
  FaDog,
  FaBed,
  FaMoneyCheckAlt,
  FaParking,
  FaWifi,
  FaBong,
} from "react-icons/fa";
import Tooltip from "./Tooltip";

const RoomIcons = (props) => {
  const { currentRoom, lease } = props;

  return (
    <div className="flex flex-wrap gap-2">
      {currentRoom.isFurnished && (
        <Tooltip
          tip="Room is furnished."
          position="-bottom-10 sm:-bottom-10"
          height=""
          width=""
          textSize="text-base"
          textColor="text-black"
          background="bg-white"
          border="border-gray-500"
          borderThickness="border-2"
          icon={false}
          helpPointer={false}
        >
          <FaBed />
        </Tooltip>
      )}
      {currentRoom.couplesOk && (
        <Tooltip
          tip="Couples are allowed"
          position="-bottom-10 sm:-bottom-10"
          height=""
          width=""
          textSize="text-base"
          textColor="text-black"
          background="bg-white"
          border="border-gray-500"
          borderThickness="border-2"
          icon={false}
          helpPointer={false}
        >
          <GiLovers />
        </Tooltip>
      )}
      {currentRoom.maleOnly && (
        <Tooltip
          tip="Males only."
          position="-bottom-10 sm:-bottom-10"
          height=""
          width=""
          textSize="text-base"
          textColor="text-black"
          background="bg-white"
          border="border-gray-500"
          borderThickness="border-2"
          icon={false}
          helpPointer={false}
        >
          <FaMale />
        </Tooltip>
      )}
      {currentRoom.femaleOnly && (
        <Tooltip
          tip="Females only."
          position="-bottom-10 sm:-bottom-10"
          height=""
          width=""
          textSize="text-base"
          textColor="text-black"
          background="bg-white"
          border="border-gray-500"
          borderThickness="border-2"
          icon={false}
          helpPointer={false}
        >
          <FaFemale />
        </Tooltip>
      )}
      {currentRoom.isCoEd && (
        <Tooltip
          tip="Property is Co-Ed."
          position="-bottom-10 sm:-bottom-10"
          height=""
          width=""
          textSize="text-base"
          textColor="text-black"
          background="bg-white"
          border="border-gray-500"
          borderThickness="border-2"
          icon={false}
          helpPointer={false}
        >
          <BiMaleFemale />
        </Tooltip>
      )}
      {currentRoom.lgbtFriendly && (
        <Tooltip
          tip="Property is LGBTQ+ friendly"
          position="-bottom-10 sm:-bottom-10"
          height=""
          width=""
          textSize="text-base"
          textColor="text-black"
          background="bg-white"
          border="border-gray-500"
          borderThickness="border-2"
          icon={false}
          helpPointer={false}
        >
          <div className="text-sm">LGBTQ+</div>
        </Tooltip>
      )}
      {currentRoom.catsOk && (
        <Tooltip
          tip="Cats are allowed."
          position="-bottom-10 sm:-bottom-10"
          height=""
          width=""
          textSize="text-base"
          textColor="text-black"
          background="bg-white"
          border="border-gray-500"
          borderThickness="border-2"
          icon={false}
          helpPointer={false}
        >
          <FaCat />
        </Tooltip>
      )}
      {currentRoom.dogsOk && (
        <Tooltip
          tip="Dogs are allowed."
          position="-bottom-10 sm:-bottom-10"
          height=""
          width=""
          textSize="text-base"
          textColor="text-black"
          background="bg-white"
          border="border-gray-500"
          borderThickness="border-2"
          icon={false}
          helpPointer={false}
        >
          <FaDog />
        </Tooltip>
      )}
      {currentRoom.smokingOk ? (
        <Tooltip
          tip="Smoking is allowed."
          position="-bottom-10 sm:-bottom-10"
          height=""
          width=""
          textSize="text-base"
          textColor="text-black"
          background="bg-white"
          border="border-gray-500"
          borderThickness="border-2"
          icon={false}
          helpPointer={false}
        >
          <FaSmoking />
        </Tooltip>
      ) : (
        <Tooltip
          tip="Smoking is not allowed."
          position="-bottom-10 sm:-bottom-10"
          height=""
          width=""
          textSize="text-base"
          textColor="text-black"
          background="bg-white"
          border="border-gray-500"
          borderThickness="border-2"
          icon={false}
          helpPointer={false}
        >
          <FaSmokingBan />
        </Tooltip>
      )}
      {currentRoom.cannabisOk && (
        <Tooltip
          tip="Cannabis is Okay"
          position="-bottom-10 sm:-bottom-10"
          height=""
          width=""
          textSize="text-base"
          textColor="text-black"
          background="bg-white"
          border="border-gray-500"
          borderThickness="border-2"
          icon={false}
          helpPointer={false}
        >
          <FaBong />
        </Tooltip>
      )}
      {currentRoom.isAccessible && (
        <Tooltip
          tip="Room is handicap accessible."
          position="-bottom-10 sm:-bottom-10"
          height=""
          width=""
          textSize="text-base"
          textColor="text-black"
          background="bg-white"
          border="border-gray-500"
          borderThickness="border-2"
          icon={false}
          helpPointer={false}
        >
          <FaWheelchair />
        </Tooltip>
      )}
      {currentRoom.laundry && (
        <Tooltip
          tip="Lanudry is available on-site."
          position="-bottom-10 sm:-bottom-10"
          height=""
          width=""
          textSize="text-base"
          textColor="text-black"
          background="bg-white"
          border="border-gray-500"
          borderThickness="border-2"
          icon={false}
          helpPointer={false}
        >
          <MdOutlineLocalLaundryService />
        </Tooltip>
      )}
      {currentRoom.parking && (
        <Tooltip
          tip="Off-street parking is available."
          position="-bottom-10 sm:-bottom-10"
          height=""
          width=""
          textSize="text-base"
          textColor="text-black"
          background="bg-white"
          border="border-gray-500"
          borderThickness="border-2"
          icon={false}
          helpPointer={false}
        >
          <FaParking />
        </Tooltip>
      )}
      {currentRoom.wifi && (
        <Tooltip
          tip="Wifi is available."
          position="-bottom-10 sm:-bottom-10"
          height=""
          width=""
          textSize="text-base"
          textColor="text-black"
          background="bg-white"
          border="border-gray-500"
          borderThickness="border-2"
          icon={false}
          helpPointer={false}
        >
          <FaWifi />
        </Tooltip>
      )}
      {lease && lease.splitsBills && (
        <Tooltip
          tip="Utilities are not included."
          position="-bottom-10 sm:-bottom-10"
          height=""
          width=""
          textSize="text-base"
          textColor="text-black"
          background="bg-white"
          border="border-gray-500"
          borderThickness="border-2"
          icon={false}
          helpPointer={false}
        >
          <FaMoneyCheckAlt />
        </Tooltip>
      )}
    </div>
  );
};

export default RoomIcons;
